/**
 * ISO 8583 Bitmap Utilities
 * - Supports primary bitmap (fields 1–64)
 * - Automatically sets bit 1 if secondary bitmap is needed (not used here)
 */

export function buildBitmap(fields: Record<number, any>): string {
  const bits = new Array(64).fill(0);

  Object.keys(fields).forEach((f) => {
    const field = Number(f);
    if (field >= 1 && field <= 64) {
      bits[field - 1] = 1;
    }
  });

  // Convert bits → hex string (16 hex chars = 64 bits)
  let hex = "";
  for (let i = 0; i < 64; i += 4) {
    const chunk = bits.slice(i, i + 4).join("");
    const val = parseInt(chunk, 2).toString(16).toUpperCase();
    hex += val;
  }

  return hex.padStart(16, "0");
}

export function parseBitmap(hexBitmap: string): number[] {
  const bits: number[] = [];

  for (let i = 0; i < hexBitmap.length; i++) {
    const nibble = parseInt(hexBitmap[i], 16)
      .toString(2)
      .padStart(4, "0");
    for (const b of nibble) {
      bits.push(Number(b));
    }
  }

  const activeFields: number[] = [];
  bits.forEach((b, idx) => {
    if (b === 1) activeFields.push(idx + 1);
  });

  return activeFields;
}